app.controller('masterManagementCtrl', function ($scope, urlServices, toaster, modalService) {
    $scope.reasonRows = [];
    $scope.reasonLoading = false;
    $scope.reasonSaving = false;
    $scope.reasonFilter = '';
    $scope.reasonForm = {
        id: 0,
        reasonName: '',
        sortOrder: 0,
        isActive: true
    };

    function resetReasonForm() {
        $scope.reasonForm = {
            id: 0,
            reasonName: '',
            sortOrder: 0,
            isActive: true
        };
    }

    function normalizeReasonRows(result) {
        return (result || []).filter(function (item) {
            return item && item.reasonName;
        });
    }

    $scope.loadReasons = function () {
        $scope.reasonLoading = true;
        urlServices.ambilData('api/e-waybill/reprint-reasons?include_inactive=1', {}, function (err, result) {
            $scope.reasonLoading = false;
            if (err) {
                return toaster.pop('error', 'Master Management', err.err || err || 'Gagal memuat reason print');
            }
            $scope.reasonRows = normalizeReasonRows(result);
        });
    };

    $scope.editReason = function (row) {
        $scope.reasonForm = {
            id: row.id || 0,
            reasonName: row.reasonName || '',
            sortOrder: row.sortOrder || 0,
            isActive: row.isActive !== false
        };
    };

    $scope.cancelReason = function () {
        resetReasonForm();
    };

    $scope.saveReason = function () {
        var payload = {
            id: $scope.reasonForm.id || 0,
            reasonName: $scope.reasonForm.reasonName || '',
            sortOrder: $scope.reasonForm.sortOrder || 0,
            isActive: $scope.reasonForm.isActive ? 1 : 0
        };
        var requestMethod = payload.id ? urlServices.updateData : urlServices.simpanData;

        if (!String(payload.reasonName || '').trim()) {
            return toaster.pop('warning', 'Master Management', 'Reason print wajib diisi');
        }

        $scope.reasonSaving = true;
        requestMethod('api/e-waybill/reprint-reasons', payload, function (err, result) {
            $scope.reasonSaving = false;
            if (err) {
                return toaster.pop('error', 'Master Management', err.err || err || 'Gagal menyimpan reason print');
            }
            $scope.reasonRows = normalizeReasonRows(result && result.items ? result.items : $scope.reasonRows);
            resetReasonForm();
            toaster.pop('success', 'Master Management', 'Reason print berhasil disimpan');
            if (!(result && result.items)) {
                $scope.loadReasons();
            }
        });
    };

    $scope.deleteReason = function (row) {
        modalService.showModal({}, {
            closeButtonText: 'No',
            actionButtonText: 'Yes',
            headerText: 'Hapus Reason Print',
            bodyText: 'Hapus reason print ' + (row.reasonName || '-') + '?'
        }).then(function (confirmed) {
            if (!confirmed) {
                return;
            }

            urlServices.hapusData('api/e-waybill/reprint-reasons/' + encodeURIComponent(row.id), {}, function (err) {
                if (err) {
                    return toaster.pop('error', 'Master Management', err.err || err || 'Gagal menghapus reason print');
                }
                if (Number($scope.reasonForm.id || 0) === Number(row.id || 0)) {
                    resetReasonForm();
                }
                toaster.pop('success', 'Master Management', 'Reason print berhasil dihapus');
                $scope.loadReasons();
            });
        });
    };

    resetReasonForm();
    $scope.loadReasons();
});